import { useQuery } from '@apollo/client';
import { Trans } from '@lingui/macro';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { Heading2 } from 'uikit/Heading';
import routes from 'utils/routeTranslator';

import { nearbyCitiesQuery, NearbyCitiesResponse } from './OrdersNearby.helpers';
import './OrdersNearby.scss';

type Props = {
  citySlug: string;
};

const RegisterOrdersNearby: FC<Props> = (props) => {
  const { data } = useQuery<NearbyCitiesResponse>(nearbyCitiesQuery, {
    variables: {
      slug: props.citySlug,
    },
  });

  if (!data) return null;

  return (
    <section id="orders-nearby">
      <div className="container">
        <Heading2>
          <Trans>Miasta w pobliżu</Trans>
        </Heading2>
        <ul className="registerOrdersNearby__items">
          {data.providerLandingRelatedCities.map((item) => (
            <li className="registerOrdersNearby__item" key={`${item.slug}-city`}>
              <Link to={routes.get('front::provider.register.city', { city: item.slug })}>{item.name}</Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default RegisterOrdersNearby;
